import { useState } from 'react';
import * as z from 'zod';
import CloseIcon from 'svg/CloseIcon';
import { Button, ButtonText } from 'components/Button';
import Modal from 'components/modals/Modal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onInvite: (email: string) => void;
}

export default function ModalInvitePartner({ isOpen, onClose, onInvite }: Props) {
  const [email, setEmail] = useState('');

  const handleClose = () => {
    setEmail('');
    onClose();
  };

  const handleNext = () => {
    if (email.trim()) {
      onInvite(email.trim());
      setEmail('');
    }
  };

  const isValidEmail = z.string().email().safeParse(email.trim()).success;

  return (
    <Modal isOpen={isOpen} handleClose={handleClose} classNameMaxWidth="max-w-lg">
      <div className="flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-color-border-input-lightmode px-6 py-5 dark:border-color-border-input-darkmode lg:px-10">
          <h2 className="typography-product-heading text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            Invite partner
          </h2>
          <ButtonText onClick={handleClose}>
            <CloseIcon className="h-6 w-6 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary" />
          </ButtonText>
        </div>

        {/* Content */}
        <div className="flex flex-col gap-3 px-6 py-6 lg:px-10">
          <p className="text-base font-bold leading-tight text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            Enter partner email to send invitation
          </p>
          <div className="flex flex-col gap-1">
            <input
              type="email"
              placeholder="Partner email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-form"
              onKeyDown={(e) => {
                if (e.key === 'Enter' && isValidEmail) {
                  e.preventDefault();
                  handleNext();
                }
              }}
            />
            <p className="text-xs leading-[14px] text-color-text-lightmode-tertiary dark:text-color-text-darkmode-tertiary">
              Add partner email address to be officially paired.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end border-t border-color-border-input-lightmode px-6 py-5 dark:border-color-border-input-darkmode lg:px-10">
          <Button
            variant="primary"
            size="lg"
            isInline
            disabled={!isValidEmail}
            onClick={handleNext}
          >
            Next
          </Button>
        </div>
      </div>
    </Modal>
  );
}
